import { createFileRoute } from "@tanstack/react-router";
import { Reveal } from "@/components/common/reveal";
import { BreadcrumbNav } from "@/components/common/breadcrumb-nav";
import { siteConfig } from "@/config/site";
import roomDining from "@/assets/room-dining.jpg";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: `Our Story & Materials — ${siteConfig.name}` },
      {
        name: "description",
        content:
          "How Aster Decorz makes artificial plants worth keeping: silk leaves, real timber, UV-stable pigment and small-run production.",
      },
      { property: "og:title", content: `Our Story & Materials — ${siteConfig.shortName}` },
      {
        property: "og:description",
        content: "Silk leaves, real timber and small-run production from India.",
      },
    ],
    links: [{ rel: "canonical", href: `${siteConfig.url}/about` }],
  }),
  component: About,
});

function About() {
  return (
    <div className="pb-28 pt-24 md:pt-28">
      <div className="section-container">
        <Reveal>
          <p className="eyebrow">Studio</p>
          <h1 className="mt-6 max-w-3xl">We make plants for rooms that don't get enough light</h1>
        </Reveal>

        <div className="mt-20 grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-6">
            <img
              src={roomDining}
              alt="Dining nook with artificial stems in a ceramic vase"
              loading="lazy"
              width={1400}
              height={1000}
              className="w-full object-cover"
            />
          </Reveal>
          <div className="space-y-10 lg:col-span-5 lg:col-start-8">
            <Reveal delay={100}>
              <h2 className="font-display text-2xl">Made in small runs</h2>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
                Every tree is assembled by hand in our workshop, leaf by leaf, onto trunks of real
                reclaimed timber. Runs are capped at three hundred pieces so nothing becomes
                generic.
              </p>
            </Reveal>
            <Reveal delay={180}>
              <h2 className="font-display text-2xl">Materials we trust</h2>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
                Hand-dyed silk, matte polymer veining, UV-stable pigment and stoneware pots. No
                plastic sheen, no shortcuts.
              </p>
            </Reveal>
            <Reveal delay={260}>
              <h2 className="font-display text-2xl">Care & returns</h2>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
                Dust with a soft brush twice a year, and enjoy {siteConfig.shipping.returnDays}-day returns in
                the original crate.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  );
}
